import styled from 'styled-components';
import { Breadcrumbs, FlexColumn } from '@elementary/common-ui/components';
import { space } from '@elementary/common-ui/style/utils';
import Password from './Password';
import PersonalInfo from './PersonalInfo';

const Wrapper = styled(FlexColumn)`
  width: 100%;
  gap: ${space('xxl')};
`;

const MyProfile = () => (
  <Wrapper>
    <Breadcrumbs items={['User', 'My Profile']} showTreeButton={false} />
    <PersonalInfo />
    <Password />
  </Wrapper>
);

export default MyProfile;
